import React, { PureComponent, PropTypes } from 'react';
import moment from 'moment-timezone';
import EventAccountData from './EventAccountData';
import { commonPropTypes } from '../../util/constants';
import {
  extractTimeTba,
  extractScheduled,
  extractZoneId,
  extractDurationMinutes,
  isAccountData
} from '../../util/EventUtil';
import { CANCELLED_STYLE } from './EventLocalDate';

const ONE_MIN_MS = 1000 * 60;
const ONE_HOUR_MS = ONE_MIN_MS * 60;
const WITH_TZ = 'LT z';
const WITHOUT_TZ = 'LT';

const TBA_TIME = <span>(TBA)</span>;

export default class EventScheduled extends PureComponent {
  static propTypes = {
    event: commonPropTypes.EVENT_SHAPE,
    showDuration: PropTypes.bool,
    showTimezone: PropTypes.bool
  };

  static defaultProps = {
    showDuration: false,
    showTimezone: true
  };

  render() {
    const { className, event, showDuration, showTimezone } = this.props;
    const scheduled = extractScheduled(event);
    const timezone = event.displayTimezone || extractZoneId(event);
    const isTba = extractTimeTba(event);
    const durationMinutes = extractDurationMinutes(event);
    const startMoment = moment.tz(scheduled, timezone);
    const endMoment = moment.tz(
      (durationMinutes) ? scheduled + (durationMinutes * ONE_MIN_MS) : scheduled + ONE_HOUR_MS, timezone
    );
    const cancelled = event && event.cancelled;

    let content;

    if (isTba) {
      content = TBA_TIME;
    } else if (showTimezone) {
      if (showDuration) {
        content = (
          <span>{startMoment.format(WITHOUT_TZ)} - {endMoment.format(WITH_TZ)}</span>
        );
      } else {
        content = (
          <span>{startMoment.format(WITH_TZ)}</span>
        );
      }
    } else {
      if (showDuration) {
        content = (
          <span>{startMoment.format(WITHOUT_TZ)} - {endMoment.format(WITHOUT_TZ)}</span>
        );
      } else {
        content = (
          <span>{startMoment.format(WITHOUT_TZ)}</span>
        );
      }
    }

    return (
      <EventAccountData className={className} highlighted={isAccountData(event, 'scheduled', 'durationMinutes')}>
        <span style={cancelled ? CANCELLED_STYLE : null}>{content}</span>
      </EventAccountData>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/event/EventScheduled.jsx